import { useNavigate } from "react-router-dom";

export const UnathorizedPage = () => {
  const navigate = useNavigate();
  return (
    <section className="page_404">
      <div className="container py-5">
        <div className="row">
          <div className="col-md-2 text-center">
            <p>
              <i className="fa fa-exclamation-triangle fa-5x"></i>
              <br />
              Status Code: 403
            </p>
          </div>
          <div className="col-md-10 mt-2">
            <h3>403 - ACCESS DENIED</h3>
            <p mt-2>
              Oops, You don't have permission to perform this action.
              <br />
              Please contact Administrator or Login.
            </p>
            <a
              className="btn btn-danger mt-4"
              type="button"
              onClick={() => {
                localStorage.clear();
                navigate("/");
              }}
            >
              Login Page
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
